import wizard from "jquery-wizard/dist/jquery-wizard.min.js"; // eslint-disable-line
import AOS from 'aos';

export default {
  init() {
    // JavaScript to be fired on the about us page
    jQuery(document).ready(() => {
      jQuery('body').trigger('update_checkout');
      jQuery('.wizard').wizard({
        buttonLabels: {
          next: PomeloVar.wizard_checkout.next, // eslint-disable-line
          back: PomeloVar.wizard_checkout.back, // eslint-disable-line
          finish: PomeloVar.wizard_checkout.finish, // eslint-disable-line
        },
        onNext: function(from, to) {
          if( from.index == 0 && to.index == 1 ) {
            var error = false;
            var err_message = '';
            var shipping_method = jQuery('input[name="shipping_method[0]"]').val();
            jQuery( '.validate-required input').each(function( index ) { // eslint-disable-line
              if(jQuery(this).attr('name') != 'account_password' && jQuery(this).val().length == 0 && (
                 ( jQuery('input[name=ship_to_different_address]').prop('checked') == false && jQuery(this).attr('name').indexOf('shipping_') !== 0 )
                 || ( jQuery('input[name=ship_to_different_address]').prop('checked') == true && shipping_method.indexOf('method_pick') == -1 )
                ) ) {
                error = true;
                err_message += '<div><strong>' + jQuery.trim(jQuery( this ).attr('placeholder')) + '</strong> ' + PomeloVar.wizard_checkout.requiredField + '</div>'; // eslint-disable-line
                //console.error(index + ": " + jQuery( this ).attr('name') + " => " + index + ": " + jQuery( this ).text()); // eslint-disable-line
              }
            });
            jQuery('.error-msg-checkout').html(err_message);
            if(error) {
              jQuery('.wizard').wizard('goTo', 0);
              jQuery(document).find('.validate-required').addClass('woocommerce-invalid');
              jQuery('html, body').animate({
                scrollTop: jQuery('.content-checkout').offset().top,
              }, 500);
              jQuery('.error-msg-checkout').css('display', 'block');
              if(jQuery('.woocommerce-NoticeGroup-checkout').length != 0) {
                jQuery('.woocommerce-NoticeGroup-checkout').remove();
              }
              return false;
            } else {
              jQuery('.order-progress-navigation-link-ship').removeClass('active');
              jQuery('.order-progress-navigation-link-pay').addClass('active');
              jQuery('.page-header h1').text(jQuery('.order-progress-navigation-link-pay').text());
              jQuery('.error-msg-checkout').css('display', 'none');
              AOS.refresh();
            }
          }
        },
      });

      jQuery(document).find('.validate-required').on("focusout", "input", function(){
        if(jQuery(this).val().length == 0) {
          jQuery(this).parents('p.form-row').addClass('woocommerce-invalid');
        }
      });

      jQuery('input[name="ship_to_different_address"]').trigger('change');

      jQuery(document).find('#btn_relais_colis').on("click", function(){
        jQuery(document).find('.validate-required').addClass('woocommerce-invalid');
      });

      /*jQuery(document).find('input[name=billing_postcode], input[name=shipping_postcode]').on("change keydown", function(e){
        if(jQuery('select[name=billing_country]').val() == "FR") {
          var charCode = (e.which) ? e.which : e.keyCode;
          if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
             return false;

          return true;
        }
      });*/
      function refreshCheckoutForm() {
        let shipping_method = jQuery('input[name="shipping_method[0]"]').val();
        if (shipping_method.indexOf('method_pick') !== -1) {
          jQuery('input[name=ship_to_different_address]').prop('checked', true).trigger('change');
          jQuery('#shipping_first_name_field').hide();
          jQuery('#shipping_last_name_field').hide();
          jQuery('#shipping_company_field').hide();
          jQuery('#shipping_address_2_field').hide();
          jQuery('#ship-to-different-address').hide();
          jQuery('input[name=shipping_first_name]').val(jQuery('input[name=billing_first_name]').val());
          jQuery('input[name=shipping_last_name]').val(jQuery('input[name=billing_last_name]').val());
          jQuery('.relais_colis').show();
        } else {
          jQuery('.relais_colis').hide();
          jQuery('#shipping_first_name_field').show();
          jQuery('#shipping_last_name_field').show();
          jQuery('#shipping_company_field').show();
          jQuery('#shipping_address_2_field').show();
          jQuery('#ship-to-different-address').show();
          //jQuery('input[name=ship_to_different_address]').prop('checked', false).trigger('change');
        }
      }

      if(jQuery('input[name="shipping_method[0]"]').length > 0) {
        refreshCheckoutForm();
      }

      //jQuery(document.body).on('updated_checkout', refreshCheckoutForm());
      //jQuery(document.body).on('updated_wc_div', refreshCheckoutForm());

      jQuery( document ).ajaxComplete(function( event, xhr, settings ) {
        if( settings.url.indexOf('update_order_review') > -1 ) {
          //refreshCheckoutForm();
        } else if( settings.url.indexOf('wc-ajax=checkout') > -1 ) {
          if((jQuery('.woocommerce-NoticeGroup-checkout').length != 0 || jQuery('.error-msg-checkout').length != 0) && ((jQuery('input[name="terms"]').prop('checked') == true && jQuery('.woocommerce-NoticeGroup-checkout div.alert > div').length > 0) || (jQuery('input[name="terms"]').prop('checked') == false && jQuery('.woocommerce-NoticeGroup-checkout div.alert > div').length > 1)) ) {
            jQuery('.wizard').wizard('goTo', 0);
          }
        }
      });

      jQuery('.btn_relais_colis').on("click", function(e){
        e.preventDefault();
        jQuery(document.body).trigger("update_checkout");
        jQuery('html, body').animate({
          scrollTop: jQuery('#identification').offset().top,
        }, 500);
      });

      jQuery('.checkout').on("submit", function(){
        if(jQuery('.woocommerce-NoticeGroup-checkout').length != 0) {
          jQuery('.woocommerce-NoticeGroup-checkout').remove();
        }
        if(jQuery('.error-msg-checkout').length != 0) {
          jQuery('.error-msg-checkout').empty().css('display', 'none');
        }
      });

      jQuery('[data-checkout="true"]').on("click", function(e){
        e.preventDefault();
        jQuery('.wizard').wizard('goTo', 0);
        jQuery('.order-progress-navigation-link-ship').addClass('active');
        jQuery('.order-progress-navigation-link-pay').removeClass('active');
        jQuery('.page-header h1').text(jQuery('.order-progress-navigation-link-ship').text());
        AOS.refresh();
      });

      jQuery(document).on("click", ".emballageCad h5 a", function(e) {
          e.preventDefault();
        if(jQuery('#emballage-cadeau').is(':visible')) {
          jQuery('#emballage-cadeau').slideUp();
        } else {
          jQuery('#emballage-cadeau').slideDown();
        }
      });

      let upd_cart_btn = jQuery("input[name='update_cart']");
      upd_cart_btn.hide();

      jQuery(document).on("change", ".cart-form .qty", function(){
        let upd_cart_btn = jQuery("input[name='update_cart']");
        upd_cart_btn.trigger("click");
        upd_cart_btn.hide();
      });

      jQuery("body").on("change", "select[name=billing_country]", function() {
        if(jQuery('input[name=ship_to_different_address]').prop('checked') == false) {
          jQuery(document.body).trigger('update_checkout');
        }
      });

      jQuery("body").on("change", "select[name=shipping_country]", function() {
        if(jQuery('input[name=ship_to_different_address]').prop('checked') == true) {
          jQuery(document.body).trigger('update_checkout');
        }
      });

      jQuery("#check_wrap_gift").on("change", function(){
        jQuery(".check_wrap_gift_content").toggleClass("active");
      });

      jQuery("#check_wrap_gift").trigger("change");
      jQuery('#coupon_giftwrap_submit').text('OK').addClass('float-right');

      jQuery('.btn-next-checkout, #tabcheckout h4 a').on('click', function() {
        jQuery('html, body').animate({
          scrollTop: jQuery('.content-checkout').offset().top,
        }, 500);
      });

      jQuery('#identification').on('click', function() {
        jQuery('html, body').animate({
          scrollTop: jQuery('#identification').offset().top,
        }, 500);
        jQuery(this).find('.icon-identif').toggleClass('ion-md-arrow-dropdown').toggleClass('ion-md-arrow-dropright');
        jQuery('#checkout_login_form').toggleClass('show');
      });

      jQuery('#checkout_login_form .login-create button').on('click', function() {
        jQuery('#identification').trigger('click');
        jQuery('html, body').animate({
          scrollTop: jQuery('.card-facturation').offset().top,
        }, 500);
        if(jQuery(this).hasClass('create-account')) {
          jQuery('#createaccount').trigger('click');
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-checkout.js